import { Input } from 'src/components/Input';

interface CallContextFormProps {
  contextObject: Record<string, string>;
  setContextObject: (contextObject: Record<string, string>) => void;
}

export const CallContextForm = ({
  contextObject,
  setContextObject,
}: CallContextFormProps) => {
  return (
    <div className="flex flex-col w-full gap-4">
      {Object.keys(contextObject).map((key) => (
        <div key={key} className="flex flex-col w-full gap-2">
          <span>{key}</span>

          <Input
            value={contextObject[key]}
            onChange={(e) =>
              setContextObject({
                ...contextObject,
                [key]: e.target.value,
              })
            }
            className="w-full"
          />
        </div>
      ))}
    </div>
  );
};
